import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { arePageFlagsPending, EventSettingsContextType, useEventSettings } from '../../../lib/context-providers/event-settings-context/event-settings-context';
import EventDetails from '../../shared/EventDetails';
import { LayoutWrapper } from './LayoutWrapper';
import isEnabledRoute from '../../../hooks/use-enabled-route';
import { IAuthContext, useAuth } from '../../../lib/context-providers/auth-context';
import { PassportPageType, SessionsPageType } from '../../../lib/api/custom-page.types';
import { ROOT } from '../../../config/routes/paths';
import { usePathPrefix } from '../../../hooks/use-path-prefix';
import { normalizeRoutePath } from '../../../lib/helpers/urlHelper';

const SessionWrapper: React.FC = () => {
  const auth = useAuth() as IAuthContext;
  const isAuthenticated = !!auth.isAuthenticated;
  const isLoading = auth.isLoading;
  const pathPrefix = usePathPrefix();

  const eventData = useEventSettings() as EventSettingsContextType;
  const enabledRoute = isEnabledRoute(eventData?.landingPage);

  if (!eventData || isLoading || arePageFlagsPending(eventData)) return null;

  const pageConfiguration = eventData.customPages?.find(el => el.type === PassportPageType.SESSIONS) as SessionsPageType | undefined;

  if (isAuthenticated && !eventData.sessionEnabled) {
    return <Redirect to={enabledRoute} />;
  }

  if (!isAuthenticated && !pageConfiguration?.publicEnabled) {
    return <Redirect to={normalizeRoutePath(ROOT, pathPrefix)} />;
  }

  if (!pageConfiguration) return null;

  return (
    <>
      <EventDetails details={eventData} />
      <LayoutWrapper
        event={{
          ...eventData,
          layout: pageConfiguration.layout,
          defaultCarouselView: pageConfiguration.defaultCarouselView,
          sessionLabel: pageConfiguration.label,
          sessionNotes: pageConfiguration.sessionNotes,
          pastSessionsEnabled: pageConfiguration.pastSessionsEnabled
        }}
      />
    </>
  );
};

export default SessionWrapper;